<template>
  <div class="grading-header">
    <div class="header-main">
      <h1 class="station-title">{{ station.name }}</h1>
      <div class="candidate-info">
        <span class="candidate-name">{{ candidate.name }}</span>
        <span class="candidate-id">({{ candidate.id }})</span>
      </div>
    </div>
    
    <div class="header-stats">
      <div class="stat">
        <span class="stat-label">Progress</span>
        <span class="stat-value">{{ completionStats.percentage }}%</span>
      </div>
      <div class="stat">
        <span class="stat-label">Graded</span>
        <span class="stat-value">{{ completionStats.graded }}/{{ completionStats.total }}</span>
      </div>
      <div class="stat">
        <span class="stat-label">Score</span>
        <span class="stat-value">{{ totalScore }}/{{ maxPossibleScore }}</span>
      </div>
    </div>
    
    <div class="header-filters">
      <button
        v-for="filter in filters"
        :key="filter.key"
        @click="handleFilterChange(filter.key)"
        class="filter-btn"
        :class="{ active: currentFilter === filter.key }"
      >
        {{ filter.label }}
        <span v-if="filter.count !== undefined && filter.count > 0" class="filter-count">
          {{ filter.count }}
        </span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GradingHeader',
  props: {
    station: {
      type: Object,
      required: true,
      default: () => ({ name: '', criteria: [] })
    },
    candidate: {
      type: Object,
      required: true,
      default: () => ({ name: '', id: '' })
    },
    completionStats: {
      type: Object,
      required: true,
      default: () => ({ percentage: 0, graded: 0, total: 0, remaining: 0 })
    },
    totalScore: {
      type: Number,
      default: 0
    },
    maxPossibleScore: {
      type: Number,
      default: 0
    },
    currentFilter: {
      type: String,
      default: 'all'
    },
    flaggedCount: {
      type: Number,
      default: 0
    }
  },
  
  computed: {
    filters() {
      return [
        { 
          key: 'all', 
          label: 'All Criteria',
          count: undefined
        },
        { 
          key: 'ungraded', 
          label: 'Ungraded', 
          count: this.completionStats.remaining 
        },
        { 
          key: 'flagged', 
          label: 'Flagged', 
          count: this.flaggedCount 
        }
      ];
    }
  },
  
  methods: {
    handleFilterChange(filterKey) {
      this.$emit('criteria-filter', filterKey);
    }
  }
}
</script>

<style scoped>
.grading-header {
  background: white;
  padding: 20px;
  border-bottom: 1px solid #e9ecef;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.header-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.station-title {
  font-size: 1.5em;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
}

.candidate-info {
  font-size: 1.1em;
  color: #495057;
}

.candidate-name {
  font-weight: 500;
}

.candidate-id {
  color: #6c757d;
  font-family: monospace;
}

.header-stats {
  display: flex;
  gap: 30px;
  margin-bottom: 15px;
}

.stat {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.stat-label {
  font-size: 0.8em;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stat-value {
  font-size: 1.2em;
  font-weight: 600;
  color: #495057;
}

.header-filters {
  display: flex;
  gap: 10px;
}

.filter-btn {
  padding: 6px 12px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  background: #f8f9fa;
  color: #495057;
  cursor: pointer;
  font-size: 0.9em;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: all 0.2s ease;
}

.filter-btn:hover {
  background: #e9ecef;
  border-color: #adb5bd;
}

.filter-btn.active {
  background: #007bff;
  border-color: #007bff;
  color: white;
}

.filter-count {
  background: #6c757d;
  color: white;
  border-radius: 10px;
  padding: 1px 6px;
  font-size: 0.8em;
  min-width: 20px;
  text-align: center;
}

.filter-btn.active .filter-count {
  background: white;
  color: #007bff;
}

@media (max-width: 768px) {
  .header-main {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  .header-stats {
    gap: 15px;
  }
  
  .stat-value {
    font-size: 1.1em;
  }
  
  .header-filters {
    flex-wrap: wrap;
  }
}
</style>